// CopyMergeAccumulationCodeList.js
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./CopyMergeAccumulationCodeListConfig";
import { screenInfo } from "./CopyMergeAccumulationCodeListConfig";
import {
  ROUTE_PATHS,
  externalProgram,
} from "../../common_nextgen/utils/Constants";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
const { ACCUMULATION_CODE_LIST } = ROUTE_PATHS;

const CopyMergeAccumulationCodeList = ({ mode }) => {
  const location = useLocation();
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];

  let {
    selectedPriceSchedules = [],
    previousScreen = ACCUMULATION_CODE_LIST,
    formData,
    currentIndex: initialIndex = 0,
    scheduleName = "",
    initialParamsData = {},
  } = currentState;

  // const { selectedPriceSchedules = [{ al1AccumulationCodeLst: "ACLIST1", al1AccumCodeListDescr: "Description 1" }, { al1AccumulationCodeLst: "ACLIST2", al1AccumCodeListDescr: "Description 2" }, { al1AccumulationCodeLst: "ACLIST3", al1AccumCodeListDescr: "Description 3" }], previousScreen = '/deductible-schedule', currentIndex: initialIndex = 0 } = location.state || {};
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  // const [initialFormData, setInitialFormData] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();
  let [initialFormData, setInitialFormData] = useState(
    useMemo(() => {
      const {
        al1AccumulationCodeLst: dtlAl1AccumulationCodeLst = "",
        al1AccumCodeListDescr: dtlAl1AccumCodeListDescr = "",
      } = selectedPriceSchedules[currentIndex];
      return { dtlAl1AccumulationCodeLst, dtlAl1AccumCodeListDescr };
    }, [selectedPriceSchedules, currentIndex])
  );

  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  // const handleBack = () => {
  //   if (currentIndex < selectedPriceSchedules.length - 1) {
  //     setCurrentIndex(currentIndex + 1);
  //   } else {
  //     navigateToPage(previousScreen, { priceSchedule: selectedPriceSchedules[currentIndex] });
  //   }
  // };

  const handleBack = () => {
    if (currentIndex < selectedPriceSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const lastScheduleName =
        selectedPriceSchedules[currentIndex]?.al1AccumulationCodeLst;
      const updatedParamsData = {
        ...currentState.paramsData,
        al1AccumulationCodeLst: lastScheduleName,
      };
      navigateToPage(previousScreen, [
        ...previousState,
        {
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
      ]);
    }
  };

  const getPageTitle = () => {
    const { screenTitle, screenNumber } = screenInfo;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    const data = {
      ...dataForSubmission,
      screenNumber: screenInfo.screenNumber,
    };
    const url = "api/al1AccumulationCodeLst/copy";
    const verb = "POST";
    try {
      const { responseStatus } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      selectedPriceSchedules[currentIndex].al1AccumulationCodeLst =
        data.dtlAccumulationCodeList;
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields == null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    keyFunc["F12"] = handleBack;
    keyName["F12"] = "Back";
    // Add other key functions and names here...
    return [keyFunc, keyName];
  }, [currentIndex]);

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     const url = `api/priceschedule/${selectedPriceSchedules[currentIndex]}`;
  //     try {
  //       const { responseData } = await axios_helper_no_header('GET', url, null, null);
  //       setInitialFormData(responseData);
  //     } catch (error) {
  //       const { responseStatus: { message } } = error.data;
  //       toast.current.show({ severity: 'error', summary: '', detail: message, life: 3000 });
  //     }
  //   };
  //   fetchInitialData();
  // }, [currentIndex]);

  useEffect(() => {
    setInitialFormData({ ...initialFormData, ...initialParamsData });
  }, [currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={mode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
        />
      </div>
    </div>
  );
};

export default CopyMergeAccumulationCodeList;
